import { Action } from '../../../shared/xs/actions';

export class RemoveEmailAction implements Action {
  static readonly type = '[Auth] remove email';
}
